import { Box } from '@mui/material'
import PropTypes from 'prop-types'
import React from 'react'
import { getErrorMessageFromResult } from '../../../app/utils/ErrorHandling'
import styles from './errorMessageStyle'

export default function ErrorMessage(props) {
  if (props.setFromResult) {
    if (!props.apiResult) {
      return null
    } else {
      return <p>{getErrorMessageFromResult(props.apiResult)}</p>
    }
  } else {
    if (!props.message) {
      return null
    } else {
      return (
        <Box component={'b'} sx={styles.errorMessage}>
          {props.message}
        </Box>
      )
    }
  }
}

ErrorMessage.propTypes = {
  setFromResult: PropTypes.bool.isRequired,
  apiResult: PropTypes.object,
  message: PropTypes.string,
}
